(function () {
  'use strict';

  angular.module('ringbaPortal').component('payoutSettingsList', {
    bindings: {
      payoutsListElementId: '@', // ID to be given to the list element in this component
      payoutsContainerSelector: '@', // Element which should be in the viewport while scrolling to the payouts list element. This element is not in this component
      addPayoutButtonText: '@',
      updatePayoutButtonText: '@',
      unsavedChangesText: '@',
      draggableParentSelector: '@', // Used in sortable-elements directive
      addTooltipText: '@',
      notifyPubLabel: '@',
      payoutSaveConfirmation: '@',
      payoutSettings: '<',
      isAffiliatePayouts: '<', // this will be used to show the last list item for campaign payouts
      campaignPayouts: '<',
      isNewPayoutAdded: '<',
      batchUpdatePayouts: '&',
      scrollToCampaignPayouts: '&', // Function to scroll to campaign payouts panel
      onPayoutSave: '&',
      campaignId: '<',
      readOnly: '<'
    },
    controller: PayoutSettingsListController,
    controllerAs: 'vm',
    templateUrl: '/scripts/shared/components/payout-settings-list/payout-settings-list.view.html'
  });

  function PayoutSettingsListController(
    _,
    $q,
    $scope,
    $timeout,
    $transitions,
    $uibModal,
    accountsService,
    bsLoadingOverlayService,
    bulkTagsService,
    campaignAffiliateService,
    payoutService,
    tagService,
    utils
  ) {
    'ngInject';

    const vm = this;
    let batchUpdateStarted = false;
    let killDirtyHandler;

    vm.$onInit = onInit;
    vm.$onChanges = onChanges;
    vm.$onDestroy = onDestroy;
    vm.showPayoutSettingsForm = showPayoutSettingsForm;
    vm.showAddPayoutSettingForm = showAddPayoutSettingForm;
    vm.removePayoutSetting = removePayoutSetting;
    vm.onPayoutSettingAdd = onPayoutSettingAdd;
    vm.onPayoutSettingUpdate = onPayoutSettingUpdate;
    vm.onDismissPayoutSettingForm = onDismissPayoutSettingForm;
    vm.updateTempPayoutSetting = updateTempPayoutSetting;
    vm.hidePayoutSettingsForm = hidePayoutSettingsForm;
    vm.onPayoutSorted = onPayoutSorted;
    vm.commitChanges = commitChanges;
    vm.saveAllChanges = saveAllChanges;
    vm.confirmDiscardAllChanges = confirmDiscardAllChanges;
    vm.discardAllChanges = discardAllChanges;
    vm.cancelModal = cancelModal;
    vm.getBulkTags = getBulkTags;

    function onInit() {
      if (!vm.readOnly) {
        _setListenerForStateChangeOrRefresh();
        getBulkTags();
      }
    }

    function onChanges(changesObj) {
      if(changesObj.campaignId) {
        _getTags();
      }
      if (changesObj.payoutSettings
        && (!vm.originalPayoutSettings
          || _checkIfNoChangesMadeToThePayouts()
          || !batchUpdateStarted
        )
      ) {
        vm.isPayoutFormActive = false; // Enable action icons when payouts change
        _handlePayoutSettingsChange(changesObj.payoutSettings, vm.payoutSettings, vm.isNewPayoutAdded);
        vm.originalPayoutSettings = campaignAffiliateService.segregatePayoutSettings(vm.payoutSettings);
        vm.payoutSettingsCopy = angular.copy(vm.originalPayoutSettings);
        _handlePayoutChanges();
      }
    }

    function onDestroy() {
      if (killDirtyHandler) {
        killDirtyHandler();
      }
      window.removeEventListener('beforeunload', _confirmOnRefresh);
    }

    function showAddPayoutSettingForm() {
      if (!vm.isPayoutFormActive) {
        vm.showNewPayoutSettingForm = true;
        vm.isPayoutFormActive = true;
      }
    }

    function showPayoutSettingsForm(payoutSettings) {
      if (!vm.isPayoutFormActive || vm.readOnly) {
        vm.isPayoutFormActive = true;
        payoutSettings.showPayoutSettingsForm = true;
      }
    }

    function removePayoutSetting(priority) {
      if (!vm.isPayoutFormActive) {
        for (let i = priority + 1; i < vm.payoutSettingsCopy.length; i++) {
          vm.payoutSettingsCopy[i].priority = i - 1;
        }
        vm.payoutSettingsCopy.splice(priority, 1);
        _handlePayoutChanges();
      }
    }

    function onPayoutSettingAdd(payoutSetting) {
      onDismissPayoutSettingForm();
      vm.payoutSettingsCopy = _.map(vm.payoutSettingsCopy, function(payout, index) {
        payout.priority = index + 1;
        return payout;
      });
      vm.payoutSettingsCopy.splice(0, 0, payoutSetting);
      _handlePayoutChanges();
    }

    function onPayoutSettingUpdate(payoutSetting) {
      onDismissPayoutSettingForm(payoutSetting);
      vm.onPayoutSave();
    }

    function hidePayoutSettingsForm(payoutSetting, priority) {
      if (!payoutSetting) {
        vm.showNewPayoutSettingForm = false;
      } else {
        _hidePayoutForm(priority);
      }

      vm.isPayoutFormActive = false;
    }

    function onDismissPayoutSettingForm(payoutSetting, priority) {
      hidePayoutSettingsForm(payoutSetting, priority);

      if (vm.payoutsContainerSelector && !utils.isInViewport(vm.payoutsContainerSelector)) {
        utils.scrollToElementId(vm.payoutsListElementId, 150);
      }
    }

    function onPayoutSorted(ev) {
      $timeout(function () {
        const movedPayoutSetting = vm.payoutSettingsCopy.splice(ev.oldIndex, 1)[0];
        vm.payoutSettingsCopy.splice(ev.newIndex, 0, movedPayoutSetting);

        const startChangeIndex = ev.oldIndex > ev.newIndex ? ev.newIndex : ev.oldIndex,
          endChangeIndex = ev.oldIndex > ev.newIndex ? ev.oldIndex : ev.newIndex;

        for (let i = startChangeIndex; i <= endChangeIndex; i++) {
          vm.payoutSettingsCopy[i].priority = i;
        }

        vm.payoutSettingsCopy = campaignAffiliateService.segregatePayoutSettings(vm.payoutSettingsCopy);
        $timeout(function() {
          $(vm.draggableParentSelector + ' .payt-stgs-list__sortable').removeAttr('style');
        }, 0);
        _handlePayoutChanges();
      }, 0);
    }

    function commitChanges() {
      vm.modal = $uibModal.open({
        templateUrl: '/scripts/shared/components/payout-settings-list/notify-payout-changes-confirmation.modal.html',
        scope: $scope,
        controllerAs: 'vm'
      });
    }

    function saveAllChanges() {
      batchUpdateStarted = true;
      return vm.batchUpdatePayouts({ payoutSettings: vm.payoutSettingsCopy, notifyPublishers: vm.notifyPublishersAboutPayoutChanges })
        .then(function () {
          cancelModal();
        })
        .finally(function () {
          vm.originalPayoutSettings = angular.copy(vm.payoutSettingsCopy);
          _handlePayoutChanges();
          batchUpdateStarted = false;
        });
    }

    function confirmDiscardAllChanges() {
      vm.modal = $uibModal.open({
        templateUrl: '/scripts/shared/components/payout-settings-list/discard-changes-confirmation.modal.html',
        scope: $scope,
        controllerAs: 'vm'
      });
    }

    function discardAllChanges() {
      vm.payoutSettingsCopy = angular.copy(vm.originalPayoutSettings);
      vm.isPayoutFormActive = false;
      cancelModal();
      _handlePayoutChanges();
      return $q.when({});
    }

    function cancelModal() {
      if (vm.modal) {
        vm.modal.close();
        vm.modal = null;
      }
    }

    function updateTempPayoutSetting(payoutSetting, priority, invalidInput) {
      const index = _.findIndex(vm.payoutSettingsCopy, { priority: priority });
      vm.payoutSettingsCopy.splice(index, 1, angular.copy(payoutSetting));
      if (invalidInput) {
        vm.disableSaveChangesButton = true;
      } else {
        _handlePayoutChanges();
      }
    }

    function _handlePayoutSettingsChange(payoutChanges, payoutSettings, isNewPayoutAdded) {
      if (!isNewPayoutAdded && payoutChanges.isFirstChange() && !payoutSettings) {
        _showLoader();
      } else {
        _hideLoader();
      }
    }

    function _hidePayoutForm(priority) {
      const payout = _.find(vm.payoutSettingsCopy, { priority: priority });
      delete payout.showPayoutSettingsForm;
    }

    function _showLoader() {
      vm.loading = true;
      bsLoadingOverlayService.start();
    }

    function _hideLoader() {
      vm.loading = false;
      bsLoadingOverlayService.stop();
    }

    function _setTagsFromApiResponse(response) {
      vm.availableTags = response.data;
    }

    function _getTags() {
      if (vm.campaignId) {
        tagService.getTagsByCampaign(accountsService.currentAccountId, vm.campaignId).then(_setTagsFromApiResponse);
      }
    }

    // Enable/disable Save Changes button and segregate payout settings into used and unused payouts depending on the
    // position of payout where the criteria is `Inbound Call`
    function _handlePayoutChanges() {
      vm.payoutSettingsCopy = campaignAffiliateService.segregatePayoutSettings(vm.payoutSettingsCopy);
      vm.disableSaveChangesButton = _checkIfNoChangesMadeToThePayouts();
    }

    function _checkIfNoChangesMadeToThePayouts() {
      if (!vm.payoutSettingsCopy) {
        return true;
      }

      const payoutSettingsCopy = payoutService.sanitizePayoutsForComparison(vm.payoutSettingsCopy);
      return angular.equals(vm.originalPayoutSettings, payoutSettingsCopy);
    }

    function _setListenerForStateChangeOrRefresh() {
      killDirtyHandler = $transitions.onBefore({}, _confirmOnStateChange);
      window.addEventListener('beforeunload', _confirmOnRefresh);
    }

    function _confirmOnRefresh(event) {
      if (!_checkIfNoChangesMadeToThePayouts()) {
        // We can't show a custom confirm message when page is refreshed or the tab is closed
        return event.returnValue = vm.unsavedChangesText;
      }
    }

    function _confirmOnStateChange() {
      if (!_checkIfNoChangesMadeToThePayouts()) {
        return confirm(vm.unsavedChangesText);
      }
    }

    function getBulkTags() {
      bulkTagsService.getBulkTags(accountsService.currentAccountId).then(function (response) {
        vm.uploadedBulkTags = response.data.bulkTagUploads;
      });
    }

  }
})();
